export const SEARCH_FEED_RESULT_ACTIONS_TYPES = {
	FETCH_SEARCH_FEED_RESULT_START: "SEARCH_FEED/FETCH_SEARCH_FEED_RESULT_START",
	FETCH_SEARCH_FEED_RESULT_SUCCESS:
		"SEARCH_FEED/FETCH_SEARCH_FEED_RESULT_SUCCESS",
	FETCH_SEARCH_FEED_RESULT_FAILED:
		"SEARCH_FEED/FETCH_SEARCH_FEED_RESULT_FAILED",
	RESET_SEARCH_FEED_RESULT: "SEARCH_FEED/RESET_SEARCH_FEED_RESULT",
};
